import React from "react";
import { MessageCircle } from "lucide-react";
import "./ComponenteCSS/CTAWhatsapp.css";

function CTAWhatsapp({ text = "Fale com um especialista" }) {
  return (
    <div className="cta-container">
      <a
        href="https://wa.me/5511994561403"
        className="cta-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <MessageCircle className="cta-icon" size={24} strokeWidth={2} />
        {text}
      </a>
    </div>
  );
}

export default CTAWhatsapp;
